import styled from 'styled-components';
import { AiLogoIcon } from './AiLogoIcon';

export type AiLoaderSize = 'large' | 'small' | 'medium' | 'lg' | 'sm' | 'md' | 'xs' | 'x-small';

const sizeToFontSize: Record<AiLoaderSize, string> = {
    'x-small': '12px',
    xs: '12px',
    small: '16px',
    sm: '16px',
    medium: '24px',
    md: '24px',
    large: '32px',
    lg: '32px'
};

export interface AiLoaderProps {
    /** Label text to display next to the loader */
    label: string;
    /** Size of the loader icon */
    size?: AiLoaderSize;
    /** Test ID for testing purposes */
    'data-testid'?: string;
    /** Hide loader from screen readers */
    ariaHidden?: boolean;
    /** Show AI logo icon next to the label */
    showLogo?: boolean;
}

const StyledAiLoaderWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: 100%;
`;

export const AiLoader: React.FC<AiLoaderProps> = ({
    label,
    size = 'medium',
    'data-testid': dataTestId = 'ai-loader',
    ariaHidden,
    showLogo = true
}) => {
    const fontSize = sizeToFontSize[size];

    return (
        <StyledAiLoaderWrapper
            data-testid={dataTestId}
            role={ariaHidden ? undefined : 'status'}
            aria-label={ariaHidden ? undefined : label}
            aria-hidden={ariaHidden}
        >
            {showLogo && <AiLogoIcon fontSize={fontSize} data-testid="ai-loader-logo" ariaHidden={true} />}
            <span>{label}</span>
        </StyledAiLoaderWrapper>
    );
};
